import { render, staticRenderFns } from "./topWastedItemsTrashEvents.vue?vue&type=template&id=a238fc16"
import script from "./topWastedItemsTrashEvents.js?vue&type=script&lang=js&external"
export * from "./topWastedItemsTrashEvents.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports